/**
 * navigation/appStack.tsx — the content navigator (one screen per nav target).
 * Headers are off; the sidebar is the chrome.
 */
import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import type { AppStackParamList } from './types';

import Rules from '../screens/rules/Rules';
import Proposals from '../screens/proposals/Proposals';
import RuleBuilder from '../screens/ruleBuilder/RuleBuilder';
import Performance from '../screens/performance/Performance';
import Settings from '../screens/settings/Settings';

const Stack = createNativeStackNavigator<AppStackParamList>();

export default function AppStack() {
  return (
    <Stack.Navigator initialRouteName="Rules" screenOptions={{ headerShown: false, animation: 'fade' }}>
      <Stack.Screen name="Rules" component={Rules} />
      <Stack.Screen name="Proposals" component={Proposals} />
      <Stack.Screen name="RuleBuilder" component={RuleBuilder} />
      <Stack.Screen name="Performance" component={Performance} />
      <Stack.Screen name="Settings" component={Settings} />
    </Stack.Navigator>
  );
}
